import '../utilities/index.js';
import '../doubleclick/index.js';
import '../draggable/index.js';
import '../resizable/index.js';
import '../sortable/index.js';
import '../docker/index.js';
import './window.js';